import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Tab from '@components/tabs'
import Title from '@components/title'
import React, { Fragment } from 'react'
import AdminCreated from './admin-created'
import PlayerCreated from './player-created'
import AwaitingResults from './awaiting-results'

const MatchResults = () => {
  const items = [
    { label: 'Admin Created', component: AdminCreated },
    { label: 'Player Created', component: PlayerCreated },
    { label: 'Awaiting Results', component: AwaitingResults },
  ]
  return (
    <Fragment>
      <Column>
        <Grid>
          {Array.from({ length: 4 }).map((_, i) => (
            <Analytic key={i} />
          ))}
        </Grid>

        <Title textone="Game Management >" texttwo="Match Results" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default MatchResults
